<template>
  <span>
    <div class="boss-layout-block">
      <div class="boss-text boss-layout boss-layout-gap-large pega-print-selection-top">
        <div>人事担当者</div>
        <div
          class="pega-print-staff-name-area pega-pre-wrap"
          data-test="responsible-staff-name"
        >{{ selectedResponsibleStaffName }}</div>
        <div>備考</div>
        <div
          data-test="remarks"
          class="pega-pre-wrap"
        >{{ remarks }}</div>
      </div>
    </div>
    <div
      v-if="!isCasualInterviewRequest"
      class="boss-table-wrap pega-visible"
      data-test="selections-table"
    >
      <table class="boss-table-4 pega-th-color-important">
        <tr>
          <th>選考フェーズ</th>
          <th>評価</th>
          <th>評価コメント</th>
        </tr>
        <applicant-print-selection-outline
          v-for="(selection, i) in selections"
          :key="i"
          :selection="selection"
        />
      </table>
    </div>
  </span>
</template>

<script>
import ApplicantPrintSelectionOutline from '@/components/molecules/ApplicantPrintSelectionOutline'
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  components: {
    ApplicantPrintSelectionOutline
  },
  props: {
    entryId: {
      type: Number,
      required: true
    },
    isCasualInterviewRequest: {
      type: Boolean,
      default: false
    },
    selections: {
      type: Array,
      default: () => []
    },
    selectedResponsibleStaffName: {
      type: String,
      default: ''
    },
    remarks: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters('settings', [
      'responsibles'
    ]),
    remarksRows () {
      return _.split(this.remarks, /\n/).length
    }
  }
}
</script>
